import errorReporter from '@app/errorReporter';
import { featureEnabled } from 'utils';
import template from './external_appointment_list.html';

angular.module('bb.external').component('bbExternalAppointmentList', {
  bindings: {},
  controller: ExternalAppointmentListCtrl,
  controllerAs: 'vm',
  template,
});
ExternalAppointmentListCtrl.$inject = [
  '$location',
  '$q',
  '$routeParams',
  '$window',
  '$scope',
  'appointmentListsService',
  'ExternalService',
  'ErrorService',
  'ToastService',
  'UtilService',
  'ExternalAuth',
];

function ExternalAppointmentListCtrl(
  $location,
  $q,
  $routeParams,
  $window,
  $scope,
  appointmentListsService,
  ExternalService,
  ErrorService,
  ToastService,
  UtilService,
  ExternalAuth,
) {
  const vm = this;
  vm.auth = ExternalAuth.auth;
  vm.$onInit = () => {
    vm.dashboardId = $routeParams.dashboardId;
    vm.listingId = $routeParams.listingId;
    vm.page = 1;
    vm.appointmentsLoaded = false;
    vm.miscDataLoaded = false;
    vm.limit = 20;
    vm.sortBy = 'time DESC';
    vm.formatDate = date => moment(date, 'YYYY-MM-DD').format('ddd, MMM Do');
    if ($routeParams.status) vm.status = $routeParams.status;
    if ($routeParams.error) vm.errorMessage = $routeParams.error;

    if (vm.errorMessage) {
      ToastService.add({
        message: `Could not sync calendar: ${vm.errorMessage}`,
        type: 'danger',
      });
    }

    // Prevents error toast message on listing appointment page when redirecting from old seller/tenant/landlord dashboard to new client dashboard
    if (!vm.listingId && !$routeParams.appointmentId) return;

    vm.showDetailsRevamp = true;
    if ($routeParams.appointmentId) {
      $location.path(
        `/dash/${vm.auth.dashboardId}/showing/${$routeParams.appointmentId}`,
      );
    }

    const miscDataPromises = [
      // server date
      UtilService.getServerDate(),
      !vm.listingId
        ? ExternalService.getDashboardNotifications(
            vm.auth.dashboardId,
            $routeParams.appointmentId,
          )
        : ExternalService.getDashboardNotificationsForListing(
            vm.auth.dashboardId,
            vm.listingId,
          ),
    ];

    $q.all(miscDataPromises)
      .then(([{ date }, contact]) => {
        vm.serverDate = date;
        vm.showFeedback = contact.notifications?.['Feedback Collected'];
      })
      .catch(({ data: error }) => {
        ToastService.add({
          message: `${error.message}`,
          type: 'danger',
        });
      })
      .finally(() => {
        vm.miscDataLoaded = true;
      });

    if ($routeParams.appointmentId) {
      ExternalService.getAppointment(
        $routeParams.dashboardId,
        $routeParams.appointmentId,
      )
        .then(appointment => {
          vm.selectedAppointment = appointment;
        })
        .catch(err => {
          ErrorService.toastyHTTPErr(err);
        })
        .finally(() => {
          vm.appointmentsLoaded = true;
        });
    } else if ($routeParams.listingId) {
      appointmentListsService
        .getExternalAppointmentsForListing(
          vm.dashboardId,
          vm.listingId,
          vm.page,
          vm.limit,
          vm.sortBy,
        )
        .then(({ appointments, permissions }) => {
          vm.totalCount = appointments.totalCount;
          vm.page += 1;
          vm.loadMoreAppointments =
            vm.page <= Math.ceil(vm.totalCount / vm.limit);
          vm.appointments = appointments.appointments;
          vm.permissions = permissions;
          vm.appointmentsLoaded = true;
        })
        .catch(({ data: error }) => {
          ToastService.add({
            message: `Listing appointments error: ${error.message}`,
            type: 'danger',
          });
        });
    } else {
      appointmentListsService
        .getExternalAppointments(vm.page, vm.limit, vm.dashboardId, vm.sortBy)
        .then(({ appointments, permissions }) => {
          vm.totalCount = appointments.totalCount;
          vm.page += 1;
          vm.loadMoreAppointments =
            vm.page <= Math.ceil(vm.totalCount / vm.limit);
          vm.appointments = appointments.appointments;
          vm.permissions = permissions;
          vm.listing = vm.appointments[0].listing;
          vm.appointmentsLoaded = true;
        });
    }

    vm.isShowingAgentVisible = vm.auth?.user?.type !== 'client';

    if (vm.dashboardId && vm.listingId && !vm.isShowingAgentVisible) {
      appointmentListsService
        .getExternalListingConfig(vm.dashboardId, vm.listingId)
        .then(({ displayedToSeller }) => {
          vm.isShowingAgentVisible =
            Boolean(displayedToSeller) && vm.auth?.user?.country === 'USA';
        });
    }
  };

  vm.dataLoaded = () => vm.appointmentsLoaded && vm.miscDataLoaded;

  vm.showButton = (appointmentId, buttonStatus) =>
    vm.permissions[appointmentId] &&
    vm.permissions[appointmentId][buttonStatus];

  vm.sort = sortBy => {
    vm.sortBy = sortBy;
    vm.page = 1;
    vm.appointments = [];
    vm.loadMore();
  };

  vm.loadMore = () => {
    if (vm.loadMoreAppointments) {
      if ($routeParams.listingId) {
        appointmentListsService
          .getExternalAppointmentsForListing(
            vm.dashboardId,
            vm.listingId,
            vm.page,
            vm.limit,
            vm.sortBy,
          )
          .then(({ appointments, permissions }) => {
            vm.page += 1;
            vm.loadMoreAppointments =
              vm.page <= Math.ceil(vm.totalCount / vm.limit);
            vm.permissions = Object.assign(vm.permissions, permissions);
            vm.appointments = vm.appointments.concat(appointments.appointments);
            vm.appointments = vm.appointments.map(apt => {
              apt.link = `#/dash/${apt.privateLink}/status/`;
              return apt;
            });
          });
      } else {
        appointmentListsService
          .getExternalAppointments(vm.page, vm.limit, vm.dashboardId, vm.sortBy)
          .then(({ appointments, permissions }) => {
            vm.page += 1;
            vm.loadMoreAppointments =
              vm.page <= Math.ceil(vm.totalCount / vm.limit);
            vm.permissions = Object.assign(vm.permissions, permissions);
            vm.appointments = vm.appointments.concat(appointments.appointments);
            vm.appointments = vm.appointments.map(apt => {
              apt.link = `#/dash/${apt.privateLink}/status/`;
              return apt;
            });
          });
      }
    }
  };

  vm.clearSelected = () => {
    vm.selectedAppointment = null;
  };

  vm.actionButton = (type, appointment) => {
    vm.status = type;
    vm.selectedAppointment = appointment;
  };

  vm.clickListing = appointment => {
    if (appointment.status === 'historical') return;
    vm.selectedAppointment = appointment;
    $location.path(`/dash/${vm.dashboardId}/appointments/${appointment.id}`);
  };
}
